String.isNullOrEmpty = function (value) {
  return (!value || value === undefined || value === "" || value.length === 0);
};
